<template lang="pug">
  .module__main
    .module-content__container(v-loading="isLoading")
      .settings__container
        .setting__container
          .setting__title Лимит автоматического подтверждения BTC
          .setting__block
            el-input(v-model="btcAutoConfirmLimit" step="0.001" type="number" placeholder="Максимальная сумма")
            el-button(size="mini" type="primary" @click="requestUpdateSetting('btcAutoConfirmLimit')") Обновить
        .setting__container
          .setting__title Лимит автоматического подтверждения USDT
          .setting__block
            el-input(v-model="usdtAutoConfirmLimit" type="number" placeholder="Максимальная сумма")
            el-button(size="mini" type="primary" @click="requestUpdateSetting('usdtAutoConfirmLimit')") Обновить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ADD_WHITELIST_WALLET, DELETE_WHITELIST_WALLET, LOAD_SETTINGS, UPDATE_SETTING } from '@/store/const/settings';
import instruments from '@/mixins/instruments';

export default {
  name: 'Settings',
  mixins: [instruments],
  data() {
    return {
      btcAutoConfirmLimit: 0,
      usdtAutoConfirmLimit: 0,
    };
  },
  async mounted() {
    await this.loadAndSetSettings();
  },
  computed: {
    ...mapGetters(['loading', 'error']),
    isLoading() {
      return this.loading(LOAD_SETTINGS) === 'loading';
    },
  },
  methods: {
    ...mapActions('settings', {
      loadSettings: LOAD_SETTINGS,
      updateSetting: UPDATE_SETTING,
    }),
    async loadAndSetSettings() {
      const request = await this.loadSettings();
      if (request.success) {
        const settings = request.data;
        for (const settingName of Object.keys(settings)) {
          this[settingName] = settings[settingName];
        }
      }
    },
    async requestUpdateSetting(setting) {
      this.$confirm('Вы уверены, что хотите обновить настройку?', 'Подтверждение обновления')
        .then(async () => {
          let settingValue;
          if (setting === 'btcAutoConfirmLimit' || setting === 'usdtAutoConfirmLimit') {
            settingValue = parseFloat(this[setting]);
          } else {
            settingValue = this[setting];
          }
          const request = await this.updateSetting({ name: setting, setting: settingValue });
          await this.notifyRequestResult({ request, successMessage: 'Настройка обновлена' });
        })
        .catch(() => {
          this.$message.info('Обновление отменено');
        });
    },
  },
};
</script>
<style scoped>
.settings__container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.setting__container {
  width: 240px;
  padding: 10px;
  background-color: white;
  margin: 5px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px #9f9f9f;
}

.setting__container.wide {
  width: 480px;
}

.setting__title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

.setting__block {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin-bottom: 5px;
}

.setting-block__title {
  font-weight: 500;
  flex: 1;
}

.wallet-address__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 5px auto;
}

.wallet-address_text {
  font-size: 12px;
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wallet-address__btn {
  margin-left: 5px;
}
</style>
